import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { authGoogleSession } from "../lib/api";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const nav = useNavigate();
    const { loginWithToken } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            nav("/login", { replace: true });
            return;
        }
        const sid = match[1];

        // Clean URL right away (security: don't leave session_id in browser history)
        window.history.replaceState({}, document.title, window.location.pathname);

        (async () => {
            try {
                const data = await authGoogleSession(sid);
                await loginWithToken(data.access_token, data.user);
                toast.success(`Benvenuto, ${data.user.name || data.user.email}`);
                if (data.migrated > 0) {
                    toast.info(`Migrati ${data.migrated} dati dal profilo anonimo al tuo account`);
                }
                nav("/", { replace: true, state: { user: data.user } });
            } catch (err) {
                toast.error("Login Google fallito");
                nav("/login", { replace: true });
            }
        })();
    }, [nav, loginWithToken]);

    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="text-center">
                <img src="/capitaly-icon.png" alt="" width={48} height={48} className="mx-auto mb-3 animate-pulse" />
                <div className="text-sm text-mute tracking-widest">ACCESSO IN CORSO…</div>
            </div>
        </div>
    );
}
